import { useCallback, useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import {
  closeConciergeWidget,
  openConciergeWidget,
  toggleConciergeWidget,
  setMaximized as setMaximizedAction,
} from "../../redux/reducers/conciergeWidget";
import { useLocation } from "react-router-dom";

export const useConciergeWidget = () => {
  const isOpen = useAppSelector((state) => state.conciergeWidget.isOpen);
  const isMaximized = useAppSelector((state) => state.conciergeWidget.isMaximized);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const prevLocation = useRef(location);

  const toggle = useCallback(() => {
    dispatch(toggleConciergeWidget());
  }, [dispatch]);

  const closeWidget = useCallback(() => {
    dispatch(closeConciergeWidget());
  }, [dispatch]);

  const openWidget = useCallback(() => {
    dispatch(openConciergeWidget());
  }, [dispatch]);

  const setMaximized = useCallback((maximized: boolean) => {
    dispatch(setMaximizedAction(maximized));
  }, [dispatch]);

  useEffect(() => {
    if (location !== prevLocation.current) {
      closeWidget();
    }
    prevLocation.current = location;
  }, [location, closeWidget]);

  return {
    isOpen,
    isMaximized,
    toggle,
    closeWidget,
    openWidget,
    setMaximized,
  };
};
